module.exports = __webpack_public_path__ + "officialStatic/img/aboutUsBg.ea5e5a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/aboutUsBg.jpg
// module id = 1QAd
// module chunks = 0